import React from 'react';
import Skeleton from 'react-loading-skeleton';

import * as S from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <S.HeaderWrapper>
      <Skeleton width="100%" height={30} />
    </S.HeaderWrapper>
  );
};

export default SkeletonLoading;
